import React from 'react'

const ButtonForIcon = ({className, onClick, children, style, type, title, text}) => {
  return (
    <button className={className} style={style} onClick={onClick} type={type} title={title}>
      {children}
      {text && <span className="btn-text">{text}</span>}
    </button>
  )
}

export default ButtonForIcon